import { render, staticRenderFns } from "./AccrualsEstimateCommentsTab.vue?vue&type=template&id=21f330ee&scoped=true"
import script from "./AccrualsEstimateCommentsTab.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimateCommentsTab.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimateCommentsTab.vue?vue&type=style&index=0&id=21f330ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f330ee",
  null
  
)

export default component.exports